export default __webpack_public_path__ + "53af85bbb7737ad858a05e4fa1acdd82.png";